module.exports = __webpack_public_path__ + "static/media/yes.e4ba3da3.png";